import { render, staticRenderFns } from "./OptionShowImagesTab.vue?vue&type=template&id=36286e34"
import script from "./OptionShowImagesTab.vue?vue&type=script&lang=ts"
export * from "./OptionShowImagesTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports